module.exports = __webpack_public_path__ + "static/media/middle-twoedge-3.bba6b2d1.png";